
import Swiper from 'vux/src/components/swiper/swiper.vue'

import wxConfig from '@/assets/js/wx_config'
export default {
name: "invite_in",
components:{
Swiper,
},
data(){
return{
swImgUrlList:new Array(),
bgDiv:new Object(),
bgImg:new Object(),
circleId:this.$route.query.circleId,
inviteUserId:this.$route.query.inviteUserId
}
},
mounted() {
this.$store.commit('UPDATE_HEAD',false);
this.$store.commit('UPDATE_FOOTER',false);
this.$store.commit('UPDATE_PAGE_TITLE','棉花IN邀请');
document.title = '棉花IN邀请'
this.initSwiperImgUrl()
this.init()

},
methods:{
init(){
this.bgDiv = document.getElementById("bgDiv");
this.bgImg = document.getElementById("bgImg");



if(wxConfig.isWeiXin()) {
this.callback();
}
},
async callback(){
let self = this
let code = this.baseFun.getQueryString('code');
if(null != code){
let falg = await this.login(code);
if(falg === 'success'){
let circleInfo = await this.getCircleInfo();
let userInfo = await this.getUserInfo();
let userId = userInfo.userId;

let userLength = circleInfo.users.filter(item => item.userId === userId).length
if(userLength === 0){
this.$vux.confirm.show({
content:'<span style="letter-spacing:2px">邀请您加入<span style="color:#FF8900">'+ circleInfo.name +'</span>相册，一起记录美好时刻吧</span>',
confirmText:'同意',
cancelText:'不同意',

onCancel () {

},
onConfirm () {
self.joinCircle(userId)
}
})
}
}else{
this.$store.commit('UPDATE_LOADING',false);
}

}
},
joinCircle(userId){
let self = this;
this.baseAjax({
url:'/circle/joinCircle',
showLoading:false,
type:'post',
data:{
"circleId":this.circleId,
"userId":userId
},
success:function (data) {
if(data.resultCode === 0){
self.$vux.toast.show({
text: '加入相册成功',
type:'text',
position:'middle',
width:'60%',
})
}
}
})
},
login(code){
let self = this
return new Promise((resolve, reject) => {
self.baseAjax({
url:'/user/login',
showLoading:true,
type:'post',
data:{
"code":code,
"mode":3
},
success:function (data) {
if(data.resultCode === 0){
resolve('success')
}else{
resolve('error')
}
}
})
})
},
getUserInfo(){
let self = this
let joinToken = window.sessionStorage.getItem('joinToken')
return new Promise((resolve, reject) => {
self.baseAjax({
url:'/user/get',
showLoading:false,
type:'post',
authentication:joinToken,
data:{},
success:function (data) {
if(data.resultCode === 0){
resolve(data.user)
}else{
resolve('error')
}
}
});
})
},
getCircleInfo(){
let self = this
return new Promise((resolve, reject) => {
self.baseAjax({
url:'/circle/getCircleInfo',
showLoading:false,
type:'post',
data:{
"circleId":this.circleId,
"userId":this.inviteUserId
},
success:function (data) {
if(data.resultCode === 0){
resolve(data.circle)
}else{
resolve('error')
}
}
});
})
},
initSwiperImgUrl(){
this.swImgUrlList.push({"url": "javascript:","img": "http://matl.oss-cn-beijing.aliyuncs.com/image/slide/iamge01@3x.jpg?x-oss-process=style/thumbnail_hd"})
this.swImgUrlList.push({"url": "javascript:","img": "http://matl.oss-cn-beijing.aliyuncs.com/image/slide/iamge02@3x.jpg?x-oss-process=style/thumbnail_hd"})
this.swImgUrlList.push({"url": "javascript:","img": "http://matl.oss-cn-beijing.aliyuncs.com/image/slide/iamge03@3x.jpg?x-oss-process=style/thumbnail_hd"})
this.swImgUrlList.push({"url": "javascript:","img": "http://matl.oss-cn-beijing.aliyuncs.com/image/slide/iamge04@3x.jpg?x-oss-process=style/thumbnail_hd"})
},
parCatyUpdateHeight(e){

let diffHeight = window.screen.height;
this.$nextTick(() => {
this.$refs.cateSwiper.xheight =  diffHeight + 'px'
})
},
downloadApp(){
if (this.checkIsAppleDevice()) {
window.location.href = "https://apps.apple.com/cn/app/%E6%A3%89%E8%8A%B1in/id1533577677";
}else {
if(wxConfig.isWeiXin()){

this.bgDiv.style.display="flex";
this.bgImg.style.display="flex";
}else{
window.location.href = "http://cdn.matl.binstar.vip/appVersion/mhi.apk?t=" + new Date().getTime();
}
}
},
checkIsAppleDevice(){
let u = navigator.userAgent, app = navigator.appVersion;
let ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
let iPad = u.indexOf('iPad') > -1;
let iPhone = u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1;
if (ios || iPad || iPhone) {
return true;
} else {
return false;
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/invite/invite_in.vue